module.exports = __webpack_public_path__ + "img/communitasAmerica.dab945d4.svg";